import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FundOrdersFormErrorStatesEnum {
    UpdateStatusFailed = ErrorStateScheduleEnum.FundOrdersFormErrorStatesStartIndex,
    UpdateStatusToCancelledRejected
}
